import {
  ListItemText,
  MenuItem,
  Select,
} from '@mui/material';
import {
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
} from '@mui/icons-material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './MultiSelector.scss';

/**
 * Select components are used for collecting user provided information from a list of options.
 */
const defaultProps = {
  selectorItems: [],
  values: [],
  className: '',
  onChange: () => {},
  disabled: false,
  placeholderWhenEmpty: '',
};
export default function MultiSelector(props) {
  const {
    selectorItems,
    values,
    className,
    onChange,
    disabled,
    placeholderWhenEmpty,
    ...rest
  } = { ...defaultProps, ...filterUndefined(props) };
  return selectorItems && selectorItems.length > 0 ? (
    <Select
      multiple
      value={values}
      variant='outlined'
      autoWidth
      onChange={onChange}
      className={`multi-selector ${className}`}
      data-dd-privacy='mask'
      renderValue={(selected) => selected.join(', ')}
      disabled={disabled}
      {...rest}
    >
      {selectorItems && selectorItems.length > 0 && selectorItems.map((object) => (
        <MenuItem style={{ whiteSpace: 'normal' }} key={object.value} value={object.value}>
          {
            values.indexOf(object.value) > -1 ? <CheckBoxIcon color='primary' className='margin-right-medium' /> : <CheckBoxOutlineBlankIcon color='primary' className='margin-right-medium' />
          }
          <ListItemText data-dd-privacy='mask' primary={object.name} />
        </MenuItem>
      ))}
    </Select>
  ) : (
    <Select
      value=''
      variant='outlined'
      autoWidth
      displayEmpty
      className={`multi-selector ${className} multi-selector-diabled`}
      disabled
      {...rest}
    >
      <MenuItem value='' disabled>{placeholderWhenEmpty}</MenuItem>
    </Select>
  );
}
